import { api } from '@/api'
import createApplePayPaymentPayload from './createApplePayPayload'
import ApplePayConfigs from './configs'

export default class AppleService {
  orderId = null

  async createOrder({ cartHash }) {
    try {
      const {
        data: {
          data: { id },
        },
      } = await api.post('api/v1/step/order/create', {
        payment_method: ApplePayConfigs.payment_method,
        cart: cartHash,
      })

      this.orderId = id
    } catch (error) {
      throw Error(error)
    }
  }

  async sendPayment({ appleToken, cart, installment }) {
    const payload = createApplePayPaymentPayload({
      appleToken,
      cart,
      installment,
      orderId: this.orderId,
    })

    try {
      const response = await api.post('/api/v1/step/apple-pay/payment', payload)
      return response
    } catch (error) {
      throw Error(error)
    }
  }

  async pay({ cart, appleToken, installment }) {
    try {
      await this.createOrder({ cartHash: cart.hash })
      await this.sendPayment({ appleToken, cart, installment })
      return true
    } catch (error) {
      return false
    }
  }
}
